module.exports = __webpack_public_path__ + "static/media/boy-19.b0fa05d0.svg";